import { createContext } from 'react';
import { createMachine } from "xstate";


//models
import { Cart } from '../Models/Cart';


export const productShopMachine = createMachine({
    id: "errorDataFetch",
    initial: "wating",
    context: { cart: {productos:[], total:0, totalCash:0, nProducts:0}, hasDiscountItem:false} as { cart: Cart, hasDiscountItem:boolean},
    states: {
      wating: {
        on: {
            ADD: { target: "adding"  },
            DISC: { target: "discounting"  },
            EDIT: { target: "edit"  },
            SET: { target: "charge"  },
            DELETE: { target: "delete"  },

        },
        entry: "calculateCart",

      },
      adding: {
        after: { 50: "wating" },
        entry: "addCart",
      },
      charge: {
        after: { 50: "wating" },
        entry: "chargeCart",
      },
      discounting: {
        after: { 50: "wating" },
        entry: "supCart",
      },
      edit: {
        after: { 50: "wating" },
        entry: "editQuantity",
      },
      delete: {
        after: { 50: "wating" },
        entry: "deleteCart",
      },

    },
  }, 
      /* actions */
  { actions: {
      // action implementations
     calculateCart:(context, event) => {
        let cartAux = context.cart
        let cantidad = 0
        let total = 0
        let totalCash = 0

        for (let index = 0; index < cartAux.productos.length; index++) {
          let element = cartAux.productos[index];
          cartAux.productos[index].subTotal = (element.producto.discount_price ? element.producto.discount_price : element.producto.price) * element.cantidad 
          cartAux.productos[index].subTotalCash = (element.producto.discount_price ? element.producto.discount_price : element.producto.cash_price) * element.cantidad 
         
          cantidad+= element.cantidad
          total+= (element.producto.discount_price ? element.producto.discount_price : element.producto.price) * element.cantidad 
          totalCash+= (element.producto.discount_price ? element.producto.discount_price : element.producto.cash_price) * element.cantidad 

          

        }
        cartAux.nProducts = cantidad
        cartAux.total = total
        cartAux.totalCash = totalCash
        context.cart = cartAux

      },

      chargeCart:(context, event) => {
        context.cart = event.data.cart;
      },

      deleteCart:(context, event) => {
        context.cart = {productos:[], total:0, nProducts:0, totalCash:0}
        context.hasDiscountItem= false
      },

      addCart:(context, event) => {
        let cartAux = context.cart
        let cardDisc = context.cart
        let inventaryAux = event.data.producto;

        console.log("evento", event)
        if(!cartAux.productos.find(x => x.producto.id === inventaryAux.id)){
            cartAux.productos.push({producto: event.data.producto , cantidad:1, subTotal: event.data.producto.price, subTotalCash:event.data.producto.cash_price, type:"product" })
        }

        // cardDisc.productos = cartAux.productos.filter(x => x.producto.discount)
        if(cartAux.productos.filter(x => x.producto.discount).length>0){
          context.hasDiscountItem= true
        }else{
          context.hasDiscountItem= false
        }
        context.cart = cartAux

      },

      supCart:(context, event) => {
        let cartAux = context.cart
        let cardDisc = context.cart
        let inventaryAux = event.data.producto;

        cartAux.productos = cartAux.productos.filter(x => x.producto.id !== inventaryAux.id)
        // cardDisc.productos = cartAux.productos.filter(x => x.producto.discount)
        if(cartAux.productos.filter(x => x.producto.discount).length>0){
          context.hasDiscountItem= true
        }
        else{
          context.hasDiscountItem= false
        }
        context.cart = cartAux

      },

      editQuantity:(context, event) => {
        let cartAux = context.cart
        let inventaryAux = event.data.producto;
        let quantity = event.data.quantity

        for (let index = 0; index < cartAux.productos.length; index++) {
          let element = cartAux.productos[index];

          if(element.producto.id === inventaryAux.id){
            cartAux.productos[index].cantidad = quantity
          }
        }

        context.cart = cartAux

      },

    }
  });
